<template>
    <div class="mlanguage" :class="{dark: dark_mode}">
        <select v-model="selected" v-on:change="changeLang()" :class="{dark: dark_mode}">
            <option v-for="lang in languages" :value="lang.id" :key="lang.id" :selected="lang.selected">{{lang.name}}</option>
        </select>
    </div>
</template>
<script>

import i18n from '@/i18n';

export default {
    name: 'Language',
    components: {i18n},
    props: { dark_mode: { type: Boolean, default: false } },
    data(){
        return {
            languages: [
                {id: 'ca', name: 'Català'},
                {id: 'es', name: 'Castellano'},
                // {id: 'en', name: 'English'},
            ],
            selected: ''
        }
    },
    computed: {},
    created(){},
    mounted(){},
    methods: {
        changeLang(){
            this.$store.commit('user/setLanguage',this.selected);
            i18n.loadLanguageAsync(this.selected);
            localStorage.setItem("language", this.selected);
        }
    },
    computed: {
        user: {
            get: function(){
                var user = this.$store.getters['user/getUser'];
                this.selected = user.language;
                return user;
            }
        }
    },
    watch: {
        user: function(){
            this.selected = this.user.language;
        }
    }
}
</script>
<style lang="scss" scoped>

    .mlanguage {
      @include background( $image: img('down.svg'), $size: 10px, $position: right 0px center );
      padding-right: 8px;
      display: block;
      float: left;
      width: 50px;

      &.dark {
          @include background( $image: img('down_w.svg'), $size: 10px, $position: right 0px center );
      }

      select {
        @include background( $image: img('lang_dark.svg'), $size: 30px, $position: right 8px center );
        padding: 6px;
        width: 50px;
        height: 100%;
        font-size: 16px;
        outline: none;
        color: transparent;
        cursor: pointer;

        &.dark {
             @include background( $image: img('lang_ffffff.svg'), $size: 30px, $position: right 8px center );
        }
      }

      select option {
        font-size: 16px;
      }

    }

</style>